import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList} from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import axios from "axios";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import StakingAddModal from "../partials/StakingAddModal";
import StakingUpdateModal from "../partials/StakingUpdateModal";
import { toast, ToastContainer} from "react-toastify";
import $ from 'jquery';
import keys from "../../actions/config";
const url = keys.baseUrl;

class Staking extends Component {
    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "stakingName",
                text: "Staking",
                className: "stakingName",
                align: "left",
                sortable: false,
                width:200
            },
            {
                key: "status",
                text: "status",
                className: "status",
                align: "left",
                sortable: false
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                cell: record => {
                    return (
                        <Fragment>
                            {/*<button
                                data-toggle="modal"
                                data-target="#update-staking-modal"
                                className="btn btn-primary btn-sm mr-2"
                                onClick={() => this.editRecord(record)}
                                >
                                <i className="fa fa-edit"></i>
                            </button>*/}
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => this.deleteRecord(record)}>
                                <i className="fa fa-trash"></i>
                            </button>
                        </Fragment>
                    );
                }
            }
        ];

        this.config = {
            page_size: 10,
            length_menu: [ 10, 20, 50 ],
            filename: "Staking",
            no_data_text: 'No Stacking found!',
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: []
        };

        this.state = {
            currentRecord: {
                id:"",
                stakingName: '',
                stakingSymbol: '',
                status: '',
            },
            errors : {}

        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData()
        this.getCurrencyData()
    };

    componentWillReceiveProps(nextProps) {
        this.getData()
    }

    getData() {
        axios
        .post(url+"api/staking")
        .then(res => {
            this.setState({ records: res.data.list})
        })
        .catch()
    }

    getCurrencyData() {
        axios
        .post(url+"api/currency")
        .then(res => {
            this.setState({ records_currency: res.data});
            var records_currency_options = [];
            for (var i = 0; i < res.data.length; i++) {
              var curRep = res.data[i];
              var _id = curRep._id;
              var currencyName = curRep.currencyName;
              var currencySymbol = curRep.currencySymbol;
              records_currency_options.push({value:_id,label:currencySymbol});
            }

            console.log('records_currency_options : ',records_currency_options);

            this.setState({ records_currency_options: records_currency_options});
        })
        .catch()
    }

    editRecord(record) {
        $("#update-staking-modal").find(".text-danger").hide();
        $("#add-staking-modal").find(".text-danger").hide();
        this.setState({ currentRecord: record,errors:{}});
    }
    addRecord() {
        $("#add-staking-modal").find(".text-danger").hide();
    }

    deleteRecord(record) {
      console.log(record);
       if(!window.confirm('Are you sure you want to delete this contract?')){ return false; }
        axios
        .post(url+"api/staking-delete", {_id: record._id})
        .then(res => {
            if (res.status === 200) {
               toast(res.data.message, {
                   position: toast.POSITION.TOP_CENTER,
               })
            }
        })
        .catch();
        this.getData();
    }

    pageChange(pageData) {
        console.log("OnPageChange", pageData);
    }

    render() {
        return (
            <div>
                <Navbar/>
                <div className="d-flex" id="wrapper">
                    <Sidebar/>
                    <StakingAddModal/>
                    <StakingUpdateModal record={this.state.currentRecord}/>
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <button onClick={() => this.addRecord()} className="btn btn-outline-primary float-right mt-0 mr-2 btn_pos_right" data-toggle="modal" data-target="#add-staking-modal"><FontAwesomeIcon icon={faPlus}/> Add Staking</button>
                            <div className="clearfix" />
                            <h3 className="mt-2 text-secondary"> Staking List</h3>
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                            />
                        </div>
                    </div>
                    <ToastContainer/>
                </div>
            </div>
        );
    }

}

Staking.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    records: state.records
});

export default connect(
    mapStateToProps
)(Staking);
